import RailsResource from './rails-resource';

class ProfessorService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'professors',
      ajaxLoader: false
    });
  }

  scheduleAudienceStats() {
    return this.call(`${this.url}/${this.resource}/schedule-audience-stats`);
  }
}

export default new ProfessorService();